import isFinite from 'lodash/isFinite';

import type { Locations } from '../LocationSection.types';

import { MAX_DISTANCE_FOR_STATIC_MAP_MAX_ZOOM, MAX_LAT, MAX_LNG } from './SwitchableMap.consts';
import type { LocationCoords, WkDocument } from './SwitchableMap.types';

export const hasFullscreenSupport = () =>
	!!document?.exitFullscreen || !!(document as WkDocument)?.webkitExitFullscreen;

export const isMaxZoomLevel = (distance: number) => distance <= MAX_DISTANCE_FOR_STATIC_MAP_MAX_ZOOM;

export const isValidLatitude = (lat: number | null): boolean => {
	if (lat === null) {
		return false;
	}

	return isFinite(lat) && Math.abs(lat) <= MAX_LAT;
};

export const isValidLongitude = (lng: number | null): boolean => {
	if (lng === null) {
		return false;
	}

	return isFinite(lng) && Math.abs(lng) <= MAX_LNG;
};

export const isValidLocation = (location: LocationCoords): boolean => {
	return isValidLatitude(location?.lat) && isValidLongitude(location?.lng);
};

export const getSellerLocation = (seller: Locations['seller']): LocationCoords => {
	if (!seller.latitude || !seller.longitude) {
		return {
			lat: null,
			lng: null,
		};
	}

	return {
		lat: seller.latitude,
		lng: seller.longitude,
	};
};
